import Icon from 'icons/Icon'
import React from 'react'

const PassIcons = ({ toggleViewPassword, setToggleViewPassword }) => {
  return (
    <span
      className='show-password-icon cursor-pointer'
      onClick={() =>
        setToggleViewPassword((toggleViewPassword) => !toggleViewPassword)}
    >
      <Icon name={toggleViewPassword ? 'show-icon-password' : 'hide-icon-password'} />
    </span>
  )
}

export default PassIcons
